import { render, staticRenderFns } from "./BeaconsEditPage.vue?vue&type=template&id=5e6d0826&"
import script from "./BeaconsEditPage.vue?vue&type=script&lang=js&"
export * from "./BeaconsEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports